export interface RoleMenuItem {
  id: string;
  groupName: string;
  name: string;
  readOnly: boolean;
  selected: boolean;
}
